<template>
  <FieldInput
    v-model="item"
    v-bind="attrBind"
    :noLabel="noLabel"
    :type="typeField"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="props">
      <slot v-bind="props" :name="slot" />
    </template>
    <template slot="append">
      <slot name="append"></slot>
      <v-icon small @click="toggleShow">{{ iconShow }}</v-icon>
    </template>
  </FieldInput>
</template>

<script>
import FieldMixin from './field-mixin'
import FieldInput from './field-input.vue'
export default {
  components: { FieldInput },
  mixins: [FieldMixin],
  props: {
    value: {},
    rules: {
      type: Array,
      default: () => [],
    },
    noLabel: Boolean,
  },
  data: () => ({
    typeField: 'password',
    iconShow: 'mdi-eye-off',
  }),
  computed: {},
  methods: {
    toggleShow() {
      if (this.typeField == 'password') {
        this.typeField = 'text'
        this.iconShow = 'mdi-eye'
      } else {
        this.typeField = 'password'
        this.iconShow = 'mdi-eye-off'
      }
    },
  },
}
</script>
